import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React from "react";

import { calcUnreadNotiCount } from "../../../libs/calcUnreadNotiCount";
import LoginHeader from "../../../organisms/LoginHeader";
import { Context, fetchCommentNotifications } from "../../../store/student";
import CommentNotifications from "../../../templates/CommentNotifications";
import styles from "../common.module.scss";

const CommentNotificationsPage = () => {
  const { dispatch, contextState } = React.useContext(Context);

  useIonViewWillEnter(() => {
    dispatch(fetchCommentNotifications());
  });

  return (
    <IonPage>
      <LoginHeader
        title="通知"
        unreadNotiCount={calcUnreadNotiCount(contextState)}
      />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <CommentNotifications
            commentNotifications={contextState.commentNotifications}
            conversationNotifications={contextState.conversationNotifications}
            feedbackNotifications={contextState.feedbackNotifications}
          />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CommentNotificationsPage;
